import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';
import { CommonMap } from 'client/tracking/maps/common';

const map = {
  minimize_canvas: TrackingEvent.actionCompleted(TrackingConstant.ACTION_TOOL_SELECT, 'minimize_canvas'),
  expand_canvas: TrackingEvent.actionCompleted(TrackingConstant.ACTION_TOOL_SELECT, 'expand_canvas'),
  exit_canvas: TrackingEvent.actionCompleted(TrackingConstant.ACTION_TOOL_SELECT, 'exit_canvas'),
  chat_canvas_dashboard: TrackingEvent.actionCompleted(TrackingConstant.ACTION_TOOL_SELECT, 'chat_canvas_dashboard'),
  user_approval_submit: TrackingEvent.actionCompleted(TrackingConstant.ENGAGE_SURVEY, 'user_approval_submit'),
  user_disapproval_submit: TrackingEvent.actionCompleted(TrackingConstant.ENGAGE_SURVEY, 'user_disapproval_submit'),
  select_autocomplete: TrackingEvent.actionStart(
    TrackingConstant.VIEW_SEARCH_RESULT,
    TrackingConstant.SELECT_AUTOCOMPLETE
  ),
  share_chat: TrackingEvent.actionCompleted(TrackingConstant.ACTION_SHARE_CONTENT, TrackingConstant.SHARE_STARTED),
  chat_canvas_tool: TrackingEvent.actionCompleted(TrackingConstant.EVENT_TYPE_ACTION_COMPLETED, 'select_microphone'),
  tool_select: TrackingEvent.actionCompleted(TrackingConstant.ACTION_TOOL_SELECT, TrackingConstant.ACTION_TOOL_SELECT),
};

export const TrackingMap = {
  ...CommonMap,
  ...map,
};
